import { RouteRecordRaw } from 'vue-router';

import { accountRoutes } from './account';
import { aggregationRoutes } from './aggregation';
import { bankPayTransactionRoutes } from './bankpay';
import { bulkGrantRoutes } from './bulk-grant';
import { bulkImportRoutes } from './bulk-import';
import { campaignRoutes } from './campaign';
import { companyRoutes } from './company';
import { fileDownloadRoutes } from './file-download';
import { giftRoutes } from './gift';
import { loginRoutes } from './login';
import { passwordRoutes } from './password';
import { physicalPrepaidCardRoutes } from './physical-prepaid-card';
import { shopRoutes } from './shop';
import { terminalRoutes } from './terminal';
import { transactionRoutes } from './transaction';
import { walletServiceRoutes } from './wallet-service';
import { walletUserRoutes } from './wallet-user';

import {
  useSystemSettingStore,
  usePhysicalPrepaidCardSettingStore,
} from '@/store';

// 認証必須ルート
const authRequiredRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    meta: { isAuthRequired: true },
    children: [{
      name: 'TwoColumn',
      component: () => import('@/components/templates/TwoColumn.vue'),
      path: '/',
      children: [
        ...bulkGrantRoutes,
        ...aggregationRoutes,
        ...bulkImportRoutes,
        ...campaignRoutes,
        ...walletServiceRoutes,
        ...companyRoutes,
        ...terminalRoutes,
        ...shopRoutes,
        ...bankPayTransactionRoutes,
        ...accountRoutes,
        ...transactionRoutes,
        ...passwordRoutes,
        ...fileDownloadRoutes,
        ...walletUserRoutes,
        ...giftRoutes,
        ...physicalPrepaidCardRoutes,
      ],
    }],
    beforeEnter: async () => {
      await Promise.all([
        useSystemSettingStore().getSystemSetting(),
        usePhysicalPrepaidCardSettingStore().getPhysicalPrepaidCardSetting(),
      ]);
    },
  }];

// [認証任意]エラー系ルート
const authNotRequiredErrorRoutes: Array<RouteRecordRaw> = [
  {
    name: 'AuthNotRequiredError',
    component: () => import('@/components/templates/OneColumn.vue'),
    path: '/',
    children: [
      {
        name: 'Forbidden',
        component: () => import('@/components/pages/403/index.vue'),
        path: '/forbidden',
        beforeEnter: (to, from, next) => {
          logger.log({ to, from }, 'TransitionForbiddenPage');
          next();
        },
      },
      {
        name: 'NotFound',
        component: () => import('@/components/pages/404/index.vue'),
        path: '/:pathMatch(.*)*',
        beforeEnter: (to, from, next) => {
          logger.log({ to, from }, 'TransitionNotFoundPage');
          next();
        },
      },
      {
        name: 'InternalServerError',
        component: () => import('@/components/pages/500/index.vue'),
        path: '/internal-server-error',
        beforeEnter: (to, from, next) => {
          logger.log({ to, from }, 'TransitionInternalServerErrorPage');
          next();
        },
      },
      {
        name: 'ServiceUnavailable',
        component: () => import('@/components/pages/503/index.vue'),
        path: '/service-unavailable',
        beforeEnter: (to, from, next) => {
          logger.log({ to, from }, 'TransitionServiceUnavailablePage');
          next();
        },
      },
    ],
  },
];

// [認証任意]ログイン系ルート
const authNotRequiredLoginRoutes: Array<RouteRecordRaw> = [
  {
    name: 'AuthNotRequiredLogin',
    component: () => import('@/components/templates/OneColumn.vue'),
    path: '/',
    children: [
      ...loginRoutes,
    ],
    beforeEnter: async () => {
      await useSystemSettingStore().getSystemSetting();
    },
  },
];

const routes: Array<RouteRecordRaw> = [{
  name: 'Root',
  component: () => import('@/components/templates/RootTemplate.vue'),
  path: '/',
  children: [
    ...authRequiredRoutes,
    ...authNotRequiredErrorRoutes,
    ...authNotRequiredLoginRoutes,
  ],
}];

export default routes;
